import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/translations';
import {   
    TEMPERTURES_COLORS,
    RAIN_COLORS,
    HUMITAT_COLORS
} from '../utils/globals';
import { Fragment } from 'react/cjs/react-jsx-runtime.production.min';



const ArametLegend = props => {

    const { language, selectedNavItem, dataAramet } = props;
    const legendItemsData = [TEMPERTURES_COLORS, RAIN_COLORS, HUMITAT_COLORS]; 
    const dataOptions = ['temperatures', 'precipitacions', 'humitat']; 
    

    let maxValor = Math.max(...dataAramet[dataOptions[selectedNavItem]].map(o => o.valors[0].valor));
    let minValor = Math.min(...dataAramet[dataOptions[selectedNavItem]].map(o => o.valors[0].valor));


    if((minValor > 0)&&(maxValor > 0)){
        minValor = 0.1;
    }else if((minValor<0)&&(maxValor<0)) {
            maxValor = 0;
    }else if((minValor===0)&&(maxValor===0)){
        maxValor = 0.1;        
    }
    
    if(minValor === -999999) minValor = 0;

    //filtra l'array de llegenda per obtenir els valors de la llegenda que es mostren en el mapa
    const filterDataLegend = (minValor, maxValor) => {
        return legendItemsData[selectedNavItem].filter(e => {            
            return (minValor >= e.condicions[0] && minValor <= e.condicions[1]) ||
                (maxValor >= e.condicions[0] && maxValor <= e.condicions[1]) ||
                (minValor <= e.condicions[0] && maxValor >= e.condicions[1]);
        });
    };

    

    let filteredLegendData = null;
    let currentPercentatge = 0;
    let gradientCSS = '';
    let percentatgeItem = 0;
    let showLegend = true;



    //si minValor i maxValor són zero o no tenim dades pq api no ha funcionat no mostrem llegenda
    if((minValor === 0 && maxValor === 0)||(dataAramet[dataOptions[selectedNavItem]].length === 0)){
        filteredLegendData = [];
        showLegend = false;
        
    }else{

        filteredLegendData = filterDataLegend(minValor, maxValor);
        percentatgeItem = 100/filteredLegendData.length;

        
            
        for ( let i = 0; i < filteredLegendData.length; i++ ) {

            currentPercentatge = (percentatgeItem*i);
            gradientCSS += `, rgb(${filteredLegendData[i].colorRGB[0]},${filteredLegendData[i].colorRGB[1]},${filteredLegendData[i].colorRGB[2]}) ${currentPercentatge}%`;
            gradientCSS += `, rgb(${filteredLegendData[i].colorRGB[0]},${filteredLegendData[i].colorRGB[1]},${filteredLegendData[i].colorRGB[2]}) ${(currentPercentatge+percentatgeItem)}%`; 
            
        }
    }


    /* Control longitud llegenda*/
    let legendWidth = '100%';
    let totalElements = filteredLegendData.length;

    if(totalElements <= 2) {
        legendWidth = '20%';
    }else if((totalElements >=3)&&(totalElements<5)){
        legendWidth = '30%';
    }else if((totalElements >=5)&&(totalElements<=7)){
        legendWidth = '50%';
    }


    


    

    /*

    let total = legendItemsData[selectedNavItem].length;


    let fromArray = 0;
    let legendData = legendItemsData[selectedNavItem];

    //per defecte 1 vol dir que pintarà tots els texts si la pantalla és petitat valdrà 2 i vol dir ke pintarà els números de les posicions parells
    let smallScreen = 1;
    

   
    //si tenim pantalla més petita de 1000px i el número d'element de la llegenda és major a 35 fem llegenda més petita
    if((windowWidth <= 1000)&&(total>35)){
       
        fromArray = 5;
        legendData = legendData.slice(fromArray, (total - fromArray) );
        total = total - (fromArray*2);
        
    }
        
    
    const percentatgeItem = 100/total;
    let currentPercentatge = 0;
    var gradientCSS = '';
    

    
    for ( let i = 0; i < legendData.length; i++ ) {
    //for ( let i = 0; i < legendItemsData[selectedNavItem].length; i++ ) {

        currentPercentatge = (percentatgeItem*i);
        gradientCSS += `, rgb(${legendData[i].colorRGB[0]},${legendData[i].colorRGB[1]},${legendData[i].colorRGB[2]}) ${currentPercentatge}%`;
        gradientCSS += `, rgb(${legendData[i].colorRGB[0]},${legendData[i].colorRGB[1]},${legendData[i].colorRGB[2]}) ${(currentPercentatge+percentatgeItem)}%`; 
        

    }

    */

        
    return (
        <div className="legend" style={{ width: legendWidth }}>
            
            { showLegend && 
                        <Fragment>                            
                            <div className="legend__title">
                                {translate(language, `aramet_legend_title_${selectedNavItem}`)}
                            </div>
                            <div className="legend__colors" 
                                style={{
                                background : 'linear-gradient(to right '+gradientCSS+')'
                                }}
                            />
                        </Fragment> 
            }
            
            <div className="legend__labels">
                {
                    filteredLegendData.map(
                        (valor, i) => {                            
                                return (
                                    <span key={valor.condicions[0]} style={{position: 'absolute',left: ((percentatgeItem*i))+'%'}}>
                                        {valor.condicions[0]}
                                    </span>                                     
                                );
                            }
                    )
                }       
                {(selectedNavItem === 1) && (filteredLegendData.length === 1) &&
                    <span key={filteredLegendData.length-1} style={{position: 'absolute',left: '100%'}}>
                        {filteredLegendData[(filteredLegendData.length-1)].condicions[1]}
                    </span>  
                }
                   
            </div>
        </div>
    );
};

ArametLegend.propTypes = {
    language: PropTypes.string,
    selectedNavItem: PropTypes.number,
    dataAramet : PropTypes.object
};

export default ArametLegend;



// WEBPACK FOOTER //
// ./src/partials/ArametLegend.js